import { call, put, takeEvery } from "redux-saga/effects"
import Moment from "moment"

// Staff Redux States
import {
  GET_HEALTHDAYS,
  GET_HEALTHDAY_DETAIL,
  ADD_HEALTHDAY,
  UPDATE_HEALTHDAY,
  ADD_HEALTHDAY_FILEUPLOAD,
  ADD_HEALTHDAY_DATAUPLOAD,
  GET_CENTRES,
  GET_CENTRE_TYPES,
  ADD_CENTRE,
  UPDATE_CENTRE,
  GET_CENTRE_DETAIL,
  GET_ETHNICITIES,
  GET_NDBNETWORKTYPES,
  GET_PHONECONTRACTS,
} from "./actionTypes"
import {
  getHealthdaysSuccess,
  getHealthdaysFail,
  getHealthdayDetailSuccess,
  getHealthdayDetailFail,
  addHealthdaySuccess,
  addHealthdayFail,
  updateHealthdaySuccess,
  updateHealthdayFail,
  addHealthdayFileUploadSuccess,
  addHealthdayFileUploadFail,
  addHealthdayDataUploadSuccess,
  addHealthdayDataUploadFail,
  getCentresSuccess,
  getCentresFail,
  getCentreTypesSuccess,
  getCentreTypesFail,
  addCentreSuccess,
  addCentreFail,
  updateCentreSuccess,
  updateCentreFail,
  getCentreDetailSuccess,
  getCentreDetailFail,
  getEthnicitiesSuccess,
  getEthnicitiesFail,
  getNDBNetworkTypesSuccess,
  getNDBNetworkTypesFail,
  getPhoneContractsSuccess,
  getPhoneContractsFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getHealthdays,
  getHealthdayDetail,
  addHealthday,
  updateHealthday,
  addHealthdayFile,
  addHealthdayDataUpload,
  getCentres,
  getCentreTypes,
  addCentre,
  updateCentre,
  getCentreDetail,
  getEthnicities,
  getPhoneContracts,
  getNDBNetworkTypes,
} from "helpers/backend_helper"

// toast
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function* fetchHealthdays() {
  try {
    const response = yield call(getHealthdays)
    yield put(getHealthdaysSuccess(response))
  } catch (error) {
    yield put(getHealthdaysFail(error))
  }
}

function* onAddHealthday({ payload: healthday }) {
  try {
    const response = yield call(addHealthday, healthday)
    yield put(addHealthdaySuccess(response))
    toast.success("Record added successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addHealthdayFail(error))
    toast.error("Failed to add new record.", { autoClose: 2000 })
  }
}

function* onUpdateHealthday({ payload: healthday }) {
  try {
    const response = yield call(updateHealthday, healthday)
    yield put(updateHealthdaySuccess(response))
    toast.success("Record updated successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(updateHealthdayFail(error))
    toast.error("Failed to update record", { autoClose: 2000 })
  }
}

function* fetchHealthdayDetail({ rowID }) {
  try {
    const response = yield call(getHealthdayDetail, rowID)
    let result = response

    result = {
      ...result,
      Centres: {
        CentreID: result.CentreID,
        Centre: result.Centre ?? "Select...",
      },
      Genders: {
        GenderID: result.GenderID,
        Gender: result.Gender ?? "Select...",
      },
      TrainingTypes: {
        GenderID: result.GenderID,
        Gender: result.Gender ?? "Select...",
      },
      Ethnicities: {
        EthnicityID: result.EthnicityID,
        Ethnicity: result.Ethnicity ?? "Select...",
      },
      PhoneContracts: {
        PhoneContractID: result.PhoneContractID,
        PhoneContract: result.PhoneContract ?? "Select...",
      },
      NDBNetworkTypes: {
        NDBNetworkTypeID: result.NDBNetworkTypeID,
        NDBNetworkType: result.NDBNetworkType ?? "Select...",
      },
      DateOfBirth: result.DateOfBirth
        ? Moment(result.DateOfBirth).format("DD MMM, YYYY")
        : "",
    }
    yield put(getHealthdayDetailSuccess(result))
  } catch (error) {
    yield put(getHealthdayDetailFail(error))
  }
}

function* fetchCentres() {
  try {
    const response = yield call(getCentres)
    console.log(response)
    yield put(getCentresSuccess(response))
  } catch (error) {
    yield put(getCentresFail(error))
  }
}

function* fetchCentreTypes() {
  try {
    const response = yield call(getCentreTypes)
    yield put(getCentreTypesSuccess(response))
  } catch (error) {
    yield put(getCentreTypesFail(error))
  }
}

function* onAddCentre({ payload: centre }) {
  try {
    const response = yield call(addCentre, centre)
    yield put(addCentreSuccess(response))
    toast.success("Centre added successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addCentreFail(error))
    if (error?.data) {
      toast.error(error?.data, { autoClose: 2000 })
    } else {
      toast.error("Failed to add Centre", { autoClose: 2000 })
    }
  }
}

function* onUpdateCentre({ payload: centre }) {
  try {
    const response = yield call(updateCentre, centre)
    yield put(updateCentreSuccess(response))
    toast.success("Centre updated successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(updateCentreFail(error))
    if (error?.data) {
      toast.error(error?.data, { autoClose: 2000 })
    } else {
      toast.error("Failed to update Centre", { autoClose: 2000 })
    }
  }
}

function* fetchCentreDetail({ rowID }) {
  try {
    const response = yield call(getCentreDetail, rowID)
    let result = response

    result = {
      ...result,
      CentreTypes: {
        CentreTypeID: result.CentreTypeID,
        CentreType: result.CentreType ?? "Select...",
      },
    }
    yield put(getCentreDetailSuccess(result))
  } catch (error) {
    yield put(getCentreDetailFail(error))
  }
}

function* fetchEthnicities() {
  try {
    const response = yield call(getEthnicities)
    yield put(getEthnicitiesSuccess(response))
  } catch (error) {
    yield put(getEthnicitiesFail(error))
  }
}

function* fetchNDBNetworkTypes() {
  try {
    let response = yield call(getNDBNetworkTypes)
    yield put(getNDBNetworkTypesSuccess(response))
  } catch (error) {
    yield put(getNDBNetworkTypesFail(error))
  }
}

function* fetchPhoneContracts() {
  try {
    let response = yield call(getPhoneContracts)
    yield put(getPhoneContractsSuccess(response))
  } catch (error) {
    yield put(getPhoneContractsFail(error))
  }
}

function* onAddHealthdayBulkFile({ payload: file }) {
  try {
    var formData = new FormData()
    formData.append("FileName", file)
    const response = yield call(addHealthdayFile, formData)
    yield put(addHealthdayFileUploadSuccess(response))
  } catch (error) {
    yield put(addHealthdayFileUploadFail(error))
  }
}

function* onAddHealthdayDataUpload() {
  try {
    const response = yield call(addHealthdayDataUpload)
    yield put(addHealthdayDataUploadSuccess(response))
    toast.success("Data uploaded successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addHealthdayDataUploadFail(error))
    toast.success("Data upload failed", { autoClose: 2000 })
  }
}

function* healthdaySaga() {
  yield takeEvery(GET_HEALTHDAYS, fetchHealthdays)
  yield takeEvery(GET_HEALTHDAY_DETAIL, fetchHealthdayDetail)
  yield takeEvery(ADD_HEALTHDAY, onAddHealthday)
  yield takeEvery(UPDATE_HEALTHDAY, onUpdateHealthday)
  yield takeEvery(GET_CENTRES, fetchCentres)
  yield takeEvery(GET_CENTRE_TYPES, fetchCentreTypes)
  yield takeEvery(ADD_CENTRE, onAddCentre)
  yield takeEvery(UPDATE_CENTRE, onUpdateCentre)
  yield takeEvery(GET_CENTRE_DETAIL, fetchCentreDetail)
  yield takeEvery(GET_ETHNICITIES, fetchEthnicities)
  yield takeEvery(GET_NDBNETWORKTYPES, fetchNDBNetworkTypes)
  yield takeEvery(GET_PHONECONTRACTS, fetchPhoneContracts)
  yield takeEvery(ADD_HEALTHDAY_FILEUPLOAD, onAddHealthdayBulkFile)
  yield takeEvery(ADD_HEALTHDAY_DATAUPLOAD, onAddHealthdayDataUpload)
}

export default healthdaySaga
